module.exports = __webpack_public_path__ + "static/media/phone-suki-app.e11e0096.png";